import script from "./HrPersonalDocuments.vue?vue&type=script&lang=ts&setup=true"
export * from "./HrPersonalDocuments.vue?vue&type=script&lang=ts&setup=true"

import "./HrPersonalDocuments.vue?vue&type=style&index=0&id=f0968c20&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0968c20"]])

export default __exports__